class ProductImageGalleryModal {
  constructor() {
    this.bindEvents();
  }

  get modal() {
    return document.querySelector('.product-image-gallery-modal');
  }

  bindEvents() {
    // Use event delegation for image buttons (works even if elements load later)
    document.addEventListener('click', (e) => {
      const button = e.target.closest('.product-image-gallery__button');
      if (button) {
        e.preventDefault();
        const mediaId = button.dataset.mediaId;
        this.openModal(mediaId);
      }

      // Close modal when clicking dark area (but not the image itself)
      const modal = e.target.closest('.product-image-gallery-modal');
      if (modal && modal.getAttribute('aria-hidden') === 'false') {
        const clickedImage = e.target.closest('.product-image-gallery-modal__image img');
        if (!clickedImage) {
          this.closeModal();
        }
      }
    });

    // Close modal on ESC key
    document.addEventListener('keydown', (e) => {
      const modal = this.modal;
      if (e.key === 'Escape' && modal && modal.getAttribute('aria-hidden') === 'false') {
        this.closeModal();
      }
    });
  }

  openModal(mediaId) {
    const modal = this.modal;
    if (!modal) return;

    // Hide all images
    const allImages = modal.querySelectorAll('.product-image-gallery-modal__image');
    for (const img of allImages) {
      img.classList.remove('active');
    }

    // Show the selected image
    const selectedImage = modal.querySelector(`[data-media-id="${mediaId}"]`);
    if (selectedImage) {
      selectedImage.classList.add('active');
    }

    // Show modal
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  closeModal() {
    const modal = this.modal;
    if (!modal) return;

    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
}

// Initialize immediately - event delegation doesn't require elements to exist
new ProductImageGalleryModal();

